// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: block;
  margin: 0;
  padding: 0;
  width: 100%;
}

.legal-center-wrapper {
  background-color: #f6f7f8;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
}
:host-context(body.theme-dark) .legal-center-wrapper {
  background-color: #111921;
}

.legal-pages-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  width: 100%;
  margin: 0;
  padding: 0;
}
:host-context(body.theme-dark) .legal-pages-header {
  background-color: #111921;
  border-bottom-color: #1f2937;
}

.legal-header-container {
  max-width: 100%;
  width: 100%;
  padding: 12px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}
@media (max-width: 1024px) {
  .legal-header-container {
    padding: 12px 24px;
    gap: 24px;
  }
}
@media (max-width: 768px) {
  .legal-header-container {
    padding: 12px 16px;
    gap: 16px;
  }
}

.legal-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}

.legal-menu-button {
  background: none;
  border: none;
  color: #111418;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  flex-shrink: 0;
}
.legal-menu-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.legal-menu-button mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
:host-context(body.theme-dark) .legal-menu-button {
  color: #d1d5db;
}
:host-context(body.theme-dark) .legal-menu-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.legal-header-logo {
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: opacity 0.2s;
}
.legal-header-logo:hover {
  opacity: 0.8;
}
.legal-header-logo img {
  height: 45px;
  width: auto;
  display: block;
}
@media (max-width: 768px) {
  .legal-header-logo img {
    height: 35px;
  }
}

.legal-header-nav {
  display: flex;
  align-items: center;
  gap: 40px;
  flex: 1;
  justify-content: center;
  min-width: 0;
  margin: 0 auto;
}
@media (max-width: 1024px) {
  .legal-header-nav {
    gap: 24px;
  }
}
@media (max-width: 768px) {
  .legal-header-nav {
    display: none;
  }
}

.legal-header-nav-link {
  font-family: "Open Sans", sans-serif;
  color: #111418;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;
  white-space: nowrap;
}
.legal-header-nav-link:hover {
  color: #5ea1d8;
}
:host-context(body.theme-dark) .legal-header-nav-link {
  color: #d1d5db;
}
:host-context(body.theme-dark) .legal-header-nav-link:hover {
  color: #5ea1d8;
}

.legal-header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Theme switch: mirror main app header toggle styles */
.header-icon {
  background: none;
  border: none;
  color: #000000;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: background-color 0.2s;
}

.header-icon:hover {
  background-color: #f0f0f0;
}

.theme-toggle-button {
  border-radius: 999px;
  padding: 2px;
  background: transparent;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.theme-toggle-button:focus,
.theme-toggle-button:active,
.theme-toggle-button:focus-visible {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.theme-toggle-button:hover {
  background: transparent;
}

.theme-toggle-track {
  width: 48px;
  height: 26px;
  border-radius: 999px;
  background: #e5e7eb;
  border: none;
  outline: none !important;
  box-shadow: none !important;
  display: inline-flex;
  align-items: center;
  padding: 1px;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.theme-toggle-track.active {
  background: #1f2937;
  border: none;
  outline: none !important;
  box-shadow: none !important;
}

.theme-toggle-thumb {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ffffff;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translateX(0);
  transition: transform 0.2s ease, color 0.2s ease;
}

.theme-toggle-track.active .theme-toggle-thumb {
  transform: translateX(22px);
  color: #f8fafc;
  background: #0f172a;
}

.theme-toggle-thumb mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.legal-sign-in-btn {
  display: flex;
  min-width: 84px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
  height: 40px;
  padding: 0 16px;
  background-color: #5ea1d8;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0.015em;
  border: none;
  transition: background-color 0.2s;
}
.legal-sign-in-btn span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.legal-sign-in-btn:hover {
  background-color: #4a8fc4;
}
@media (max-width: 768px) {
  .legal-sign-in-btn {
    min-width: auto;
    padding: 0 12px;
  }
}

.legal-center-container {
  display: grid;
  grid-template-columns: 256px 1fr 192px;
  gap: 48px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 40px;
  background-color: transparent;
  min-height: calc(100vh - 200px);
  width: 100%;
  box-sizing: border-box;
  position: relative;
  flex: 1;
}
@media (max-width: 1400px) {
  .legal-center-container {
    grid-template-columns: 240px 1fr 180px;
    gap: 40px;
    padding: 0 32px;
  }
}
@media (max-width: 1200px) {
  .legal-center-container {
    grid-template-columns: 220px 1fr 160px;
    gap: 32px;
    padding: 0 24px;
  }
}
@media (max-width: 992px) {
  .legal-center-container {
    grid-template-columns: 200px 1fr;
    gap: 24px;
    padding: 0 20px;
  }
  .legal-center-container .on-this-page-sidebar {
    display: none;
  }
}
@media (max-width: 768px) {
  .legal-center-container {
    grid-template-columns: 1fr;
    gap: 0;
    padding: 0 16px 20px 16px;
  }
  .legal-center-container .legal-sidebar {
    order: 2;
  }
  .legal-center-container .legal-main-content {
    order: 1;
  }
}

.legal-sidebar {
  background-color: #ffffff;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #f3f4f6;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 96px;
  align-self: start;
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  width: 256px;
}
@media (max-width: 1400px) {
  .legal-sidebar {
    width: 240px;
  }
}
@media (max-width: 1200px) {
  .legal-sidebar {
    width: 220px;
  }
}
@media (max-width: 992px) {
  .legal-sidebar {
    width: 200px;
  }
}
@media (max-width: 768px) {
  .legal-sidebar {
    position: relative;
    top: 0;
    width: 100%;
    border-radius: 0;
    border: none;
    border-top: 1px solid #e0e0e0;
    padding-top: 20px;
    padding-right: 0;
    box-shadow: none;
    margin-left: 0;
  }
}

.legal-sidebar-header {
  margin-bottom: 30px;
}
.legal-sidebar-header .legal-sidebar-title {
  font-size: 18px;
  font-weight: 700;
  color: #212427;
  margin: 0 0 5px 0;
}
.legal-sidebar-header .legal-sidebar-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* App-wide dark theme hook used by main layout */
:host-context(body.theme-dark) {
  /* Main column: no extra card — same surface as page (avoids double panel) */
  /* Keep hover/selection contrast readable on dark sidebars */
}
:host-context(body.theme-dark) .legal-center-wrapper,
:host-context(body.theme-dark) .legal-pages-header {
  background: #0a0c10 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .legal-sidebar,
:host-context(body.theme-dark) .on-this-page-sidebar {
  background: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .on-this-page-sidebar {
  border: 1px solid rgba(148, 163, 184, 0.25) !important;
  border-radius: 12px;
  padding: 16px 14px;
}
:host-context(body.theme-dark) .legal-main-content,
:host-context(body.theme-dark) .legal-content,
:host-context(body.theme-dark) .legal-metadata {
  background: transparent !important;
  color: #e5e7eb !important;
  border: none !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .legal-page-title,
:host-context(body.theme-dark) .legal-sidebar-title,
:host-context(body.theme-dark) .on-this-page-title,
:host-context(body.theme-dark) .legal-content h1,
:host-context(body.theme-dark) .legal-content h2,
:host-context(body.theme-dark) .legal-content h3,
:host-context(body.theme-dark) .legal-content h4 {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .legal-sidebar-subtitle,
:host-context(body.theme-dark) .legal-content p,
:host-context(body.theme-dark) .legal-content li,
:host-context(body.theme-dark) .legal-content strong,
:host-context(body.theme-dark) .breadcrumbs,
:host-context(body.theme-dark) .last-updated,
:host-context(body.theme-dark) .version {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .legal-nav-item,
:host-context(body.theme-dark) .on-this-page-link,
:host-context(body.theme-dark) .back-to-top,
:host-context(body.theme-dark) .legal-header-nav-link {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .legal-nav-item.active,
:host-context(body.theme-dark) .on-this-page-link:hover,
:host-context(body.theme-dark) .back-to-top:hover,
:host-context(body.theme-dark) .legal-header-nav-link:hover {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .legal-nav-item:hover {
  background-color: rgba(148, 163, 184, 0.16) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .legal-nav-item:hover mat-icon {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .legal-nav-item.active {
  background-color: rgba(94, 161, 216, 0.16) !important;
  border-color: rgba(94, 161, 216, 0.35) !important;
  color: #dbeafe !important;
}
:host-context(body.theme-dark) .on-this-page-link {
  display: block;
  padding: 8px 10px;
  border-radius: 8px;
}
:host-context(body.theme-dark) .on-this-page-link:hover,
:host-context(body.theme-dark) .back-to-top:hover {
  background-color: rgba(148, 163, 184, 0.14) !important;
  color: #dbeafe !important;
  text-decoration: none;
}
:host-context(body.theme-dark) .legal-menu-button:hover {
  background: rgba(148, 163, 184, 0.18) !important;
}
:host-context(body.theme-dark) .legal-pages-header .header-icon {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .legal-pages-header .header-icon:hover {
  background-color: rgba(148, 163, 184, 0.18) !important;
}
:host-context(body.theme-dark) .legal-pages-header .theme-toggle-track.active .theme-toggle-thumb mat-icon {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .legal-pages-header .theme-toggle-track:not(.active) .theme-toggle-thumb mat-icon {
  color: #6b7280 !important;
}
:host-context(body.theme-dark) .legal-center-wrapper p,
:host-context(body.theme-dark) .legal-center-wrapper span,
:host-context(body.theme-dark) .legal-center-wrapper li,
:host-context(body.theme-dark) .legal-center-wrapper strong,
:host-context(body.theme-dark) .legal-center-wrapper em,
:host-context(body.theme-dark) .legal-center-wrapper label {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .legal-nav-item mat-icon,
:host-context(body.theme-dark) .back-to-top mat-icon,
:host-context(body.theme-dark) .legal-metadata mat-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .legal-nav-item.active mat-icon,
:host-context(body.theme-dark) .back-to-top:hover mat-icon {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .legal-sign-in-btn,
:host-context(body.theme-dark) .legal-sign-in-btn span {
  color: #ffffff !important;
}

.legal-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 30px;
}

.legal-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  text-decoration: none;
  color: #212427;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
}
.legal-nav-item mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #666;
}
.legal-nav-item:hover {
  background-color: #f5f5f5;
  color: #5ea1d8;
}
.legal-nav-item:hover mat-icon {
  color: #5ea1d8;
}
.legal-nav-item.active {
  background-color: #f0f2f4;
  color: #5ea1d8;
  border: 1px solid rgba(94, 161, 216, 0.2);
  font-weight: 700;
}
.legal-nav-item.active mat-icon {
  color: #5ea1d8;
  font-variation-settings: "FILL" 1;
}

:host-context(body.theme-dark) .legal-nav-item.active {
  background-color: #1e293b;
  border-color: rgba(94, 161, 216, 0.2);
}

.download-pdf-btn {
  display: none !important;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  color: #212427;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.download-pdf-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.download-pdf-btn:hover {
  background-color: #f5f5f5;
  border-color: #5ea1d8;
  color: #5ea1d8;
}

.legal-main-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0;
  width: 100%;
}
@media (max-width: 768px) {
  .legal-main-content {
    padding: 0;
    max-width: 100%;
  }
}

.breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  font-size: 14px;
  color: #666;
}
.breadcrumbs a {
  color: #5ea1d8;
  text-decoration: none;
}
.breadcrumbs a:hover {
  text-decoration: underline;
}
.breadcrumbs .breadcrumb-separator {
  color: #999;
}
.breadcrumbs .breadcrumb-current {
  color: #212427;
}

.legal-page-title {
  font-size: 42px;
  font-weight: 700;
  color: #212427;
  margin: 0 0 20px 0;
  line-height: 1.2;
}
@media (max-width: 768px) {
  .legal-page-title {
    font-size: 32px;
  }
}

.legal-metadata {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;
  font-size: 14px;
  color: #666;
}
.legal-metadata .last-updated {
  display: flex;
  align-items: center;
  gap: 8px;
}
.legal-metadata .last-updated mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.legal-metadata .version {
  color: #999;
}

.legal-content {
  color: #212427;
  line-height: 1.8;
  font-size: 16px;
}
.legal-content h2, .legal-content h3 {
  color: #212427;
  margin-top: 40px;
  margin-bottom: 16px;
}
.legal-content h2 {
  font-size: 28px;
  font-weight: 700;
}
.legal-content h3 {
  font-size: 22px;
  font-weight: 600;
}
.legal-content p {
  margin-bottom: 16px;
  color: #333;
}
.legal-content ul {
  margin: 16px 0;
  padding-left: 24px;
}
.legal-content ul li {
  margin-bottom: 12px;
  color: #333;
  line-height: 1.8;
}
.legal-content a {
  color: #5ea1d8;
  text-decoration: none;
}
.legal-content a:hover {
  text-decoration: underline;
}

.legal-feedback {
  margin-top: 60px;
  padding-top: 40px;
  border-top: 1px solid #e0e0e0;
}
.legal-feedback .feedback-question {
  font-size: 16px;
  font-weight: 600;
  color: #212427;
  margin-bottom: 16px;
}
.legal-feedback .feedback-buttons {
  display: flex;
  gap: 12px;
}
.legal-feedback .feedback-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.legal-feedback .feedback-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.legal-feedback .feedback-btn.feedback-yes {
  color: #4caf50;
}
.legal-feedback .feedback-btn.feedback-yes:hover {
  background-color: #f1f8f4;
  border-color: #4caf50;
}
.legal-feedback .feedback-btn.feedback-no {
  color: #f44336;
}
.legal-feedback .feedback-btn.feedback-no:hover {
  background-color: #fff5f5;
  border-color: #f44336;
}

.on-this-page-sidebar {
  position: sticky;
  top: 96px;
  align-self: start;
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  width: 192px;
  padding-left: 0;
}
@media (max-width: 1400px) {
  .on-this-page-sidebar {
    width: 180px;
  }
}
@media (max-width: 1200px) {
  .on-this-page-sidebar {
    width: 160px;
    padding-left: 16px;
  }
}
@media (max-width: 992px) {
  .on-this-page-sidebar {
    display: none;
  }
}

.on-this-page-title {
  font-size: 12px;
  font-weight: 700;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0 0 16px 0;
}

.on-this-page-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
}

.on-this-page-link {
  font-size: 14px;
  color: #5ea1d8;
  text-decoration: none;
  padding: 6px 0;
  cursor: pointer;
  transition: color 0.2s ease;
}
.on-this-page-link:hover {
  color: #4a8fc4;
  text-decoration: underline;
}

.back-to-top {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
  text-decoration: none;
  padding: 8px 0;
  cursor: pointer;
  transition: color 0.2s ease;
}
.back-to-top mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.back-to-top:hover {
  color: #5ea1d8;
}

.key-takeaway {
  background-color: #e3f2fd;
  border-left: 4px solid #5ea1d8;
  padding: 20px;
  margin: 24px 0;
  border-radius: 4px;
}
.key-takeaway .key-takeaway-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.key-takeaway .key-takeaway-header mat-icon {
  color: #5ea1d8;
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.key-takeaway .key-takeaway-header .key-takeaway-title {
  font-size: 16px;
  font-weight: 600;
  color: #212427;
  margin: 0;
}
.key-takeaway .key-takeaway-content {
  color: #333;
  line-height: 1.6;
}

.data-collection-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}
.data-collection-item mat-icon {
  color: #5ea1d8;
  font-size: 20px;
  width: 20px;
  height: 20px;
  margin-top: 2px;
  flex-shrink: 0;
}
.data-collection-item .data-collection-content {
  flex: 1;
}
.data-collection-item .data-collection-content strong {
  color: #212427;
  font-weight: 600;
}

.two-column-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin: 24px 0;
}
@media (max-width: 768px) {
  .two-column-layout {
    grid-template-columns: 1fr;
  }
}
.two-column-layout .column h4 {
  font-size: 18px;
  font-weight: 600;
  color: #212427;
  margin-bottom: 16px;
}
.two-column-layout .column ul {
  list-style: none;
  padding-left: 0;
}
.two-column-layout .column ul li {
  padding-left: 20px;
  position: relative;
}
.two-column-layout .column ul li:before {
  content: "•";
  position: absolute;
  left: 0;
  color: #5ea1d8;
  font-weight: bold;
}

.footer {
  background: #000000;
  color: #ffffff;
  padding: 14px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  margin-top: auto;
}
.footer .copy-rights {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}
.footer .copy-rights .row {
  display: flex;
  align-items: center;
  margin: 0;
  width: 100%;
}
@media (max-width: 768px) {
  .footer .copy-rights .row {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
}
.footer .copy-rights .col-md-5,
.footer .copy-rights .col-md-7,
.footer .copy-rights .col-12 {
  padding: 0;
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .footer .copy-rights .col-md-5,
  .footer .copy-rights .col-md-7,
  .footer .copy-rights .col-12 {
    width: 100%;
    justify-content: flex-start;
  }
}
@media (min-width: 769px) {
  .footer .copy-rights .col-md-5 {
    justify-content: flex-start;
  }
}
@media (min-width: 769px) {
  .footer .copy-rights .col-md-7 {
    justify-content: flex-end;
  }
}
.footer .cpyrgt {
  color: #64748b !important;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.5;
  width: 100%;
}
@media (max-width: 768px) {
  .footer .cpyrgt {
    flex-wrap: wrap;
  }
}
.footer .cpyrgt li {
  color: #64748b !important;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.footer .cpyrgt li a {
  color: #64748b !important;
  text-decoration: none;
  margin-left: 4px;
}
.footer .cpyrgt li a:hover {
  color: #5ea1d8 !important;
  text-decoration: underline;
}
.footer .f-menu-right {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0;
  width: 100%;
}
@media (max-width: 768px) {
  .footer .f-menu-right {
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
.footer .f-menu-right li {
  margin: 0;
  padding: 0;
}
@media (min-width: 769px) {
  .footer .f-menu-right li:not(:last-child)::after {
    content: "|";
    margin: 0 12px;
    color: #64748b;
  }
}
.footer .f-menu-right li a {
  color: #64748b !important;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s ease;
}
.footer .f-menu-right li a:hover {
  color: #5ea1d8 !important;
  text-decoration: underline;
}

@media screen and (max-width: 992px) {
  :host footer,
  :host .footer,
  .legal-page footer,
  .legal-page .footer,
  app-legal-center-layout footer,
  app-legal-center-layout .footer {
    display: block !important;
    visibility: visible !important;
  }
}
:host-context(body.theme-light) .legal-pages-header {
  background: rgba(255, 255, 255, 0.95) !important;
  border-bottom-color: rgba(0, 0, 0, 0.08) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  -webkit-backdrop-filter: blur(20px) !important;
          backdrop-filter: blur(20px) !important;
}
:host-context(body.theme-light) .legal-menu-button {
  color: #0f172a !important;
}
:host-context(body.theme-light) .legal-menu-button:hover {
  background-color: rgba(0, 0, 0, 0.06) !important;
}
:host-context(body.theme-light) .legal-header-nav-link {
  color: rgba(15, 23, 42, 0.75) !important;
}
:host-context(body.theme-light) .legal-header-nav-link:hover {
  color: #5ea1d8 !important;
}
:host-context(body.theme-light) .legal-sign-in-btn {
  background-color: #5ea1d8 !important;
  color: #ffffff !important;
}
:host-context(body.theme-light) .legal-sign-in-btn:hover {
  background-color: #4a8fc4 !important;
}
:host-context(body.theme-light) .footer {
  background: #f1f5f9 !important;
  color: #475569 !important;
  border-top-color: rgba(0, 0, 0, 0.08) !important;
}
:host-context(body.theme-light) .footer .cpyrgt li,
:host-context(body.theme-light) .footer .cpyrgt li a,
:host-context(body.theme-light) .footer .f-menu-right li a {
  color: #64748b !important;
}
:host-context(body.theme-light) .footer .cpyrgt li a:hover,
:host-context(body.theme-light) .footer .f-menu-right li a:hover {
  color: #5ea1d8 !important;
}
:host-context(body.theme-light) .footer .f-menu-right li:not(:last-child)::after {
  color: rgba(100, 116, 139, 0.5) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/legal-center-layout/legal-center-layout.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,cAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AACF;;AAGA;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AAAF;AAGE;EACE,yBAAA;AADJ;;AAMA;EACE,gBAAA;EACA,MAAA;EACA,aAAA;EACA,yBAAA;EACA,gCAAA;EACA,yCAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAHF;AAME;EACE,yBAAA;EACA,4BAAA;AAJJ;;AAQA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AALF;AAOE;EATF;IAUI,kBAAA;IACA,SAAA;EAJF;AACF;AAME;EAdF;IAeI,kBAAA;IACA,SAAA;EAHF;AACF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAHF;;AAMA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,cAAA;AAHF;AAKE;EACE,qCAAA;AAHJ;AAME;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAJJ;AAQE;EACE,cAAA;AANJ;AAQI;EACE,0CAAA;AANN;;AAWA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;AARF;AAUE;EACE,YAAA;AARJ;AAWE;EACE,YAAA;EACA,WAAA;EACA,cAAA;AATJ;AAWI;EALF;IAMI,YAAA;EARJ;AACF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AATF;AAWE;EATF;IAUI,SAAA;EARF;AACF;AAUE;EAbF;IAcI,aAAA;EAPF;AACF;;AAUA;EACE,oCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;AAPF;AASE;EACE,cAAA;AAPJ;AAWE;EACE,cAAA;AATJ;AAWI;EACE,cAAA;AATN;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAXF;;AAcA,uDAAA;AACA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iCAAA;AAXF;;AAcA;EACE,yBAAA;AAXF;;AAcA;EACE,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,2BAAA;AAXF;;AAcA;;;EAGE,uBAAA;EACA,wBAAA;EACA,2BAAA;AAXF;;AAcA;EACE,uBAAA;AAXF;;AAcA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,2BAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,8DAAA;AAXF;;AAcA;EACE,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,2BAAA;AAXF;;AAcA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,gDAAA;AAXF;;AAcA;EACE,2BAAA;EACA,cAAA;EACA,mBAAA;AAXF;;AAcA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAXF;;AAcA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,iCAAA;AAXF;AAaE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAXJ;AAcE;EACE,yBAAA;AAZJ;AAeE;EA7BF;IA8BI,eAAA;IACA,eAAA;EAZF;AACF;;AAeA;EACE,aAAA;EACA,sCAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,+BAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,OAAA;AAZF;AAcE;EAdF;IAeI,sCAAA;IACA,SAAA;IACA,eAAA;EAXF;AACF;AAaE;EApBF;IAqBI,sCAAA;IACA,SAAA;IACA,eAAA;EAVF;AACF;AAYE;EA1BF;IA2BI,gCAAA;IACA,SAAA;IACA,eAAA;EATF;EAWE;IACE,aAAA;EATJ;AACF;AAYE;EApCF;IAqCI,0BAAA;IACA,MAAA;IACA,yBAAA;EATF;EAWE;IACE,QAAA;EATJ;EAYE;IACE,QAAA;EAVJ;AACF;;AAeA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,+BAAA;EACA,gBAAA;EACA,YAAA;AAZF;AAcE;EAbF;IAcI,YAAA;EAXF;AACF;AAaE;EAjBF;IAkBI,YAAA;EAVF;AACF;AAYE;EArBF;IAsBI,YAAA;EATF;AACF;AAWE;EAzBF;IA0BI,kBAAA;IACA,MAAA;IACA,WAAA;IACA,gBAAA;IACA,YAAA;IACA,6BAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;IACA,cAAA;EARF;AACF;;AAWA;EACE,mBAAA;AARF;AAUE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AARJ;AAWE;EACE,eAAA;EACA,WAAA;EACA,SAAA;AATJ;;AAaA,iDAAA;AACA;EAsBE,4EAAA;EA4CA,4DAAA;AA1EF;AASE;;EAEE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAPJ;AAUE;;EAEE,8BAAA;EACA,yBAAA;EACA,kDAAA;EACA,2BAAA;AARJ;AAWE;EACE,sDAAA;EACA,mBAAA;EACA,kBAAA;AATJ;AAaE;;;EAGE,kCAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;AAXJ;AAcE;;;;;;;EAOE,yBAAA;AAZJ;AAeE;;;;;;;EAOE,yBAAA;AAbJ;AAgBE;;;;EAIE,yBAAA;AAdJ;AAiBE;;;;EAIE,yBAAA;AAfJ;AAmBE;EACE,sDAAA;EACA,yBAAA;AAjBJ;AAoBE;EACE,yBAAA;AAlBJ;AAqBE;EACE,qDAAA;EACA,iDAAA;EACA,yBAAA;AAnBJ;AAsBE;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AApBJ;AAuBE;;EAEE,sDAAA;EACA,yBAAA;EACA,qBAAA;AArBJ;AAwBE;EACE,gDAAA;AAtBJ;AAyBE;EACE,yBAAA;AAvBJ;AA0BE;EACE,sDAAA;AAxBJ;AA2BE;EACE,yBAAA;AAzBJ;AA4BE;EACE,yBAAA;AA1BJ;AA6BE;;;;;;EAME,yBAAA;AA3BJ;AA8BE;;;EAGE,yBAAA;AA5BJ;AA+BE;;EAEE,yBAAA;AA7BJ;AAgCE;;EAEE,yBAAA;AA9BJ;;AAkCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AA/BF;;AAkCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AA/BF;AAiCE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AA/BJ;AAkCE;EACE,yBAAA;EACA,cAAA;AAhCJ;AAkCI;EACE,cAAA;AAhCN;AAoCE;EACE,yBAAA;EACA,cAAA;EACA,yCAAA;EACA,gBAAA;AAlCJ;AAoCI;EACE,cAAA;EACA,iCAAA;AAlCN;;AAwCA;EACE,yBAAA;EACA,qCAAA;AArCF;;AAwCA;EACE,wBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AArCF;AAuCE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AArCJ;AAwCE;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AAtCJ;;AA2CA;EACE,gBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;AAxCF;AA0CE;EANF;IAOI,UAAA;IACA,eAAA;EAvCF;AACF;;AA0CA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAvCF;AAyCE;EACE,cAAA;EACA,qBAAA;AAvCJ;AAyCI;EACE,0BAAA;AAvCN;AA2CE;EACE,WAAA;AAzCJ;AA4CE;EACE,cAAA;AA1CJ;;AA8CA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA3CF;AA6CE;EAPF;IAQI,eAAA;EA1CF;AACF;;AA6CA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AA1CF;AA4CE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA1CJ;AA4CI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA1CN;AA8CE;EACE,WAAA;AA5CJ;;AAgDA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AA7CF;AA+CE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AA7CJ;AAgDE;EACE,eAAA;EACA,gBAAA;AA9CJ;AAiDE;EACE,eAAA;EACA,gBAAA;AA/CJ;AAkDE;EACE,mBAAA;EACA,WAAA;AAhDJ;AAmDE;EACE,cAAA;EACA,kBAAA;AAjDJ;AAmDI;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;AAjDN;AAqDE;EACE,cAAA;EACA,qBAAA;AAnDJ;AAqDI;EACE,0BAAA;AAnDN;;AAwDA;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AArDF;AAuDE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AArDJ;AAwDE;EACE,aAAA;EACA,SAAA;AAtDJ;AAyDE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAvDJ;AAyDI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAvDN;AA0DI;EACE,cAAA;AAxDN;AA0DM;EACE,yBAAA;EACA,qBAAA;AAxDR;AA4DI;EACE,cAAA;AA1DN;AA4DM;EACE,yBAAA;EACA,qBAAA;AA1DR;;AAiEA;EACE,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,+BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AA9DF;AAgEE;EATF;IAUI,YAAA;EA7DF;AACF;AA+DE;EAbF;IAcI,YAAA;IACA,kBAAA;EA5DF;AACF;AA8DE;EAlBF;IAmBI,aAAA;EA3DF;AACF;;AA8DA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AA3DF;;AA8DA;EACE,eAAA;EACA,cAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;AA3DF;AA6DE;EACE,cAAA;EACA,0BAAA;AA3DJ;;AA+DA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;AA5DF;AA8DE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA5DJ;AA+DE;EACE,cAAA;AA7DJ;;AAkEA;EACE,yBAAA;EACA,8BAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;AA/DF;AAiEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA/DJ;AAiEI;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA/DN;AAkEI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAhEN;AAoEE;EACE,WAAA;EACA,gBAAA;AAlEJ;;AAuEA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AApEF;AAsEE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AApEJ;AAuEE;EACE,OAAA;AArEJ;AAuEI;EACE,cAAA;EACA,gBAAA;AArEN;;AA2EA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;AAxEF;AA0EE;EANF;IAOI,0BAAA;EAvEF;AACF;AA0EI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAxEN;AA2EI;EACE,gBAAA;EACA,eAAA;AAzEN;AA2EM;EACE,kBAAA;EACA,kBAAA;AAzER;AA2EQ;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,cAAA;EACA,iBAAA;AAzEV;;AAiFA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,+CAAA;EACA,gBAAA;AA9EF;AAgFE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AA9EJ;AAgFI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AA9EN;AAgFM;EANF;IAOI,sBAAA;IACA,uBAAA;IACA,SAAA;EA7EN;AACF;AAgFI;;;EAGE,UAAA;EACA,aAAA;EACA,mBAAA;AA9EN;AAgFM;EAPF;;;IAQI,WAAA;IACA,2BAAA;EA3EN;AACF;AA+EM;EADF;IAEI,2BAAA;EA5EN;AACF;AAgFM;EADF;IAEI,yBAAA;EA7EN;AACF;AAiFE;EACE,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA/EJ;AAiFI;EAXF;IAYI,eAAA;EA9EJ;AACF;AAgFI;EACE,yBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AA9EN;AAgFM;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;AA9ER;AAgFQ;EACE,yBAAA;EACA,0BAAA;AA9EV;AAoFE;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;AAlFJ;AAoFI;EAXF;IAYI,2BAAA;IACA,sBAAA;IACA,uBAAA;IACA,QAAA;EAjFJ;AACF;AAmFI;EACE,SAAA;EACA,UAAA;AAjFN;AAmFM;EACE;IACE,YAAA;IACA,cAAA;IACA,cAAA;EAjFR;AACF;AAoFM;EACE,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,2BAAA;AAlFR;AAoFQ;EACE,yBAAA;EACA,0BAAA;AAlFV;;AA0FA;EACE;;;;;;IAME,yBAAA;IACA,8BAAA;EAvFF;AACF;AAgGE;EACE,gDAAA;EACA,mDAAA;EACA,oDAAA;EACA,8CAAA;UAAA,sCAAA;AA9FJ;AAiGE;EACE,yBAAA;AA/FJ;AAgGI;EAAU,gDAAA;AA7Fd;AAgGE;EACE,wCAAA;AA9FJ;AA+FI;EAAU,yBAAA;AA5Fd;AA+FE;EACE,oCAAA;EACA,yBAAA;AA7FJ;AA8FI;EAAU,oCAAA;AA3Fd;AA+FE;EACE,8BAAA;EACA,yBAAA;EACA,gDAAA;AA7FJ;AA+FI;;;EAEqB,yBAAA;AA5FzB;AA8FI;;EAC2B,yBAAA;AA3F/B;AA6FI;EACE,0CAAA;AA3FN","sourcesContent":["// Component host styling - remove any default margins/padding\n:host {\n  display: block;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n\n// Legal Center Wrapper\n.legal-center-wrapper {\n  background-color: #f6f7f8;\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  padding: 0;\n\n  // Dark mode support\n  :host-context(body.theme-dark) & {\n    background-color: #111921;\n  }\n}\n\n// Legal Pages Header\n.legal-pages-header {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  background-color: #ffffff;\n  border-bottom: 1px solid #e5e7eb;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  width: 100%;\n  margin: 0;\n  padding: 0;\n\n  // Dark mode support\n  :host-context(body.theme-dark) & {\n    background-color: #111921;\n    border-bottom-color: #1f2937;\n  }\n}\n\n.legal-header-container {\n  max-width: 100%;\n  width: 100%;\n  padding: 12px 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 40px;\n\n  @media (max-width: 1024px) {\n    padding: 12px 24px;\n    gap: 24px;\n  }\n\n  @media (max-width: 768px) {\n    padding: 12px 16px;\n    gap: 16px;\n  }\n}\n\n.legal-header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-shrink: 0;\n}\n\n.legal-menu-button {\n  background: none;\n  border: none;\n  color: #111418;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n  flex-shrink: 0;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n\n  mat-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n\n  // Dark mode support\n  :host-context(body.theme-dark) & {\n    color: #d1d5db;\n\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.1);\n    }\n  }\n}\n\n.legal-header-logo {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: opacity 0.2s;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  img {\n    height: 45px;\n    width: auto;\n    display: block;\n\n    @media (max-width: 768px) {\n      height: 35px;\n    }\n  }\n}\n\n.legal-header-nav {\n  display: flex;\n  align-items: center;\n  gap: 40px;\n  flex: 1;\n  justify-content: center;\n  min-width: 0;\n  margin: 0 auto;\n\n  @media (max-width: 1024px) {\n    gap: 24px;\n  }\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n}\n\n.legal-header-nav-link {\n  font-family: \"Open Sans\", sans-serif;\n  color: #111418;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5;\n  text-decoration: none;\n  cursor: pointer;\n  transition: color 0.2s;\n  white-space: nowrap;\n\n  &:hover {\n    color: #5ea1d8;\n  }\n\n  // Dark mode support\n  :host-context(body.theme-dark) & {\n    color: #d1d5db;\n\n    &:hover {\n      color: #5ea1d8;\n    }\n  }\n}\n\n.legal-header-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* Theme switch: mirror main app header toggle styles */\n.header-icon {\n  background: none;\n  border: none;\n  color: #000000;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition: background-color 0.2s;\n}\n\n.header-icon:hover {\n  background-color: #f0f0f0;\n}\n\n.theme-toggle-button {\n  border-radius: 999px;\n  padding: 2px;\n  background: transparent;\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.theme-toggle-button:focus,\n.theme-toggle-button:active,\n.theme-toggle-button:focus-visible {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.theme-toggle-button:hover {\n  background: transparent;\n}\n\n.theme-toggle-track {\n  width: 48px;\n  height: 26px;\n  border-radius: 999px;\n  background: #e5e7eb;\n  border: none;\n  outline: none !important;\n  box-shadow: none !important;\n  display: inline-flex;\n  align-items: center;\n  padding: 1px;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.theme-toggle-track.active {\n  background: #1f2937;\n  border: none;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.theme-toggle-thumb {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #ffffff;\n  color: #6b7280;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transform: translateX(0);\n  transition: transform 0.2s ease, color 0.2s ease;\n}\n\n.theme-toggle-track.active .theme-toggle-thumb {\n  transform: translateX(22px);\n  color: #f8fafc;\n  background: #0f172a;\n}\n\n.theme-toggle-thumb mat-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n}\n\n.legal-sign-in-btn {\n  display: flex;\n  min-width: 84px;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: 8px;\n  height: 40px;\n  padding: 0 16px;\n  background-color: #5ea1d8;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5;\n  letter-spacing: 0.015em;\n  border: none;\n  transition: background-color 0.2s;\n\n  span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &:hover {\n    background-color: #4a8fc4;\n  }\n\n  @media (max-width: 768px) {\n    min-width: auto;\n    padding: 0 12px;\n  }\n}\n\n.legal-center-container {\n  display: grid;\n  grid-template-columns: 256px 1fr 192px;\n  gap: 48px;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 40px 40px;\n  background-color: transparent;\n  min-height: calc(100vh - 200px);\n  width: 100%;\n  box-sizing: border-box;\n  position: relative;\n  flex: 1;\n\n  @media (max-width: 1400px) {\n    grid-template-columns: 240px 1fr 180px;\n    gap: 40px;\n    padding: 0 32px;\n  }\n\n  @media (max-width: 1200px) {\n    grid-template-columns: 220px 1fr 160px;\n    gap: 32px;\n    padding: 0 24px;\n  }\n\n  @media (max-width: 992px) {\n    grid-template-columns: 200px 1fr;\n    gap: 24px;\n    padding: 0 20px;\n    \n    .on-this-page-sidebar {\n      display: none;\n    }\n  }\n\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n    gap: 0;\n    padding: 0 16px 20px 16px;\n\n    .legal-sidebar {\n      order: 2;\n    }\n\n    .legal-main-content {\n      order: 1;\n    }\n  }\n}\n\n// Left Sidebar - Positioned closer to content\n.legal-sidebar {\n  background-color: #ffffff;\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid #f3f4f6;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  position: sticky;\n  top: 96px;\n  align-self: start;\n  max-height: calc(100vh - 120px);\n  overflow-y: auto;\n  width: 256px;\n\n  @media (max-width: 1400px) {\n    width: 240px;\n  }\n\n  @media (max-width: 1200px) {\n    width: 220px;\n  }\n\n  @media (max-width: 992px) {\n    width: 200px;\n  }\n\n  @media (max-width: 768px) {\n    position: relative;\n    top: 0;\n    width: 100%;\n    border-radius: 0;\n    border: none;\n    border-top: 1px solid #e0e0e0;\n    padding-top: 20px;\n    padding-right: 0;\n    box-shadow: none;\n    margin-left: 0;\n  }\n}\n\n.legal-sidebar-header {\n  margin-bottom: 30px;\n\n  .legal-sidebar-title {\n    font-size: 18px;\n    font-weight: 700;\n    color: #212427;\n    margin: 0 0 5px 0;\n  }\n\n  .legal-sidebar-subtitle {\n    font-size: 14px;\n    color: #666;\n    margin: 0;\n  }\n}\n\n/* App-wide dark theme hook used by main layout */\n:host-context(body.theme-dark) {\n  .legal-center-wrapper,\n  .legal-pages-header {\n    background: #0a0c10 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  .legal-sidebar,\n  .on-this-page-sidebar {\n    background: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    box-shadow: none !important;\n  }\n\n  .on-this-page-sidebar {\n    border: 1px solid rgba(148, 163, 184, 0.25) !important;\n    border-radius: 12px;\n    padding: 16px 14px;\n  }\n\n  /* Main column: no extra card — same surface as page (avoids double panel) */\n  .legal-main-content,\n  .legal-content,\n  .legal-metadata {\n    background: transparent !important;\n    color: #e5e7eb !important;\n    border: none !important;\n    box-shadow: none !important;\n  }\n\n  .legal-page-title,\n  .legal-sidebar-title,\n  .on-this-page-title,\n  .legal-content h1,\n  .legal-content h2,\n  .legal-content h3,\n  .legal-content h4 {\n    color: #f8fafc !important;\n  }\n\n  .legal-sidebar-subtitle,\n  .legal-content p,\n  .legal-content li,\n  .legal-content strong,\n  .breadcrumbs,\n  .last-updated,\n  .version {\n    color: #cbd5e1 !important;\n  }\n\n  .legal-nav-item,\n  .on-this-page-link,\n  .back-to-top,\n  .legal-header-nav-link {\n    color: #cbd5e1 !important;\n  }\n\n  .legal-nav-item.active,\n  .on-this-page-link:hover,\n  .back-to-top:hover,\n  .legal-header-nav-link:hover {\n    color: #93c5fd !important;\n  }\n\n  /* Keep hover/selection contrast readable on dark sidebars */\n  .legal-nav-item:hover {\n    background-color: rgba(148, 163, 184, 0.16) !important;\n    color: #e2e8f0 !important;\n  }\n\n  .legal-nav-item:hover mat-icon {\n    color: #93c5fd !important;\n  }\n\n  .legal-nav-item.active {\n    background-color: rgba(94, 161, 216, 0.16) !important;\n    border-color: rgba(94, 161, 216, 0.35) !important;\n    color: #dbeafe !important;\n  }\n\n  .on-this-page-link {\n    display: block;\n    padding: 8px 10px;\n    border-radius: 8px;\n  }\n\n  .on-this-page-link:hover,\n  .back-to-top:hover {\n    background-color: rgba(148, 163, 184, 0.14) !important;\n    color: #dbeafe !important;\n    text-decoration: none;\n  }\n\n  .legal-menu-button:hover {\n    background: rgba(148, 163, 184, 0.18) !important;\n  }\n\n  .legal-pages-header .header-icon {\n    color: #ffffff !important;\n  }\n\n  .legal-pages-header .header-icon:hover {\n    background-color: rgba(148, 163, 184, 0.18) !important;\n  }\n\n  .legal-pages-header .theme-toggle-track.active .theme-toggle-thumb mat-icon {\n    color: #ffffff !important;\n  }\n\n  .legal-pages-header .theme-toggle-track:not(.active) .theme-toggle-thumb mat-icon {\n    color: #6b7280 !important;\n  }\n\n  .legal-center-wrapper p,\n  .legal-center-wrapper span,\n  .legal-center-wrapper li,\n  .legal-center-wrapper strong,\n  .legal-center-wrapper em,\n  .legal-center-wrapper label {\n    color: #cbd5e1 !important;\n  }\n\n  .legal-nav-item mat-icon,\n  .back-to-top mat-icon,\n  .legal-metadata mat-icon {\n    color: #94a3b8 !important;\n  }\n\n  .legal-nav-item.active mat-icon,\n  .back-to-top:hover mat-icon {\n    color: #5ea1d8 !important;\n  }\n\n  .legal-sign-in-btn,\n  .legal-sign-in-btn span {\n    color: #ffffff !important;\n  }\n}\n\n.legal-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 30px;\n}\n\n.legal-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  text-decoration: none;\n  color: #212427;\n  font-size: 15px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  cursor: pointer;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    color: #666;\n  }\n\n  &:hover {\n    background-color: #f5f5f5;\n    color: #5ea1d8;\n\n    mat-icon {\n      color: #5ea1d8;\n    }\n  }\n\n  &.active {\n    background-color: #f0f2f4;\n    color: #5ea1d8;\n    border: 1px solid rgba(94, 161, 216, 0.2);\n    font-weight: 700;\n\n    mat-icon {\n      color: #5ea1d8;\n      font-variation-settings: 'FILL' 1;\n    }\n  }\n}\n\n// Dark mode for sidebar active state\n:host-context(body.theme-dark) .legal-nav-item.active {\n  background-color: #1e293b;\n  border-color: rgba(94, 161, 216, 0.2);\n}\n\n.download-pdf-btn {\n  display: none !important;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 12px 16px;\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  color: #212427;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &:hover {\n    background-color: #f5f5f5;\n    border-color: #5ea1d8;\n    color: #5ea1d8;\n  }\n}\n\n// Main Content - Centered with max width\n.legal-main-content {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 0;\n  width: 100%;\n\n  @media (max-width: 768px) {\n    padding: 0;\n    max-width: 100%;\n  }\n}\n\n.breadcrumbs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 24px;\n  font-size: 14px;\n  color: #666;\n\n  a {\n    color: #5ea1d8;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  .breadcrumb-separator {\n    color: #999;\n  }\n\n  .breadcrumb-current {\n    color: #212427;\n  }\n}\n\n.legal-page-title {\n  font-size: 42px;\n  font-weight: 700;\n  color: #212427;\n  margin: 0 0 20px 0;\n  line-height: 1.2;\n\n  @media (max-width: 768px) {\n    font-size: 32px;\n  }\n}\n\n.legal-metadata {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 40px;\n  font-size: 14px;\n  color: #666;\n\n  .last-updated {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .version {\n    color: #999;\n  }\n}\n\n.legal-content {\n  color: #212427;\n  line-height: 1.8;\n  font-size: 16px;\n\n  h2, h3 {\n    color: #212427;\n    margin-top: 40px;\n    margin-bottom: 16px;\n  }\n\n  h2 {\n    font-size: 28px;\n    font-weight: 700;\n  }\n\n  h3 {\n    font-size: 22px;\n    font-weight: 600;\n  }\n\n  p {\n    margin-bottom: 16px;\n    color: #333;\n  }\n\n  ul {\n    margin: 16px 0;\n    padding-left: 24px;\n\n    li {\n      margin-bottom: 12px;\n      color: #333;\n      line-height: 1.8;\n    }\n  }\n\n  a {\n    color: #5ea1d8;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.legal-feedback {\n  margin-top: 60px;\n  padding-top: 40px;\n  border-top: 1px solid #e0e0e0;\n\n  .feedback-question {\n    font-size: 16px;\n    font-weight: 600;\n    color: #212427;\n    margin-bottom: 16px;\n  }\n\n  .feedback-buttons {\n    display: flex;\n    gap: 12px;\n  }\n\n  .feedback-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 20px;\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    background-color: #ffffff;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n\n    &.feedback-yes {\n      color: #4caf50;\n\n      &:hover {\n        background-color: #f1f8f4;\n        border-color: #4caf50;\n      }\n    }\n\n    &.feedback-no {\n      color: #f44336;\n\n      &:hover {\n        background-color: #fff5f5;\n        border-color: #f44336;\n      }\n    }\n  }\n}\n\n// Right Sidebar - Positioned closer to content\n.on-this-page-sidebar {\n  position: sticky;\n  top: 96px;\n  align-self: start;\n  max-height: calc(100vh - 120px);\n  overflow-y: auto;\n  width: 192px;\n  padding-left: 0;\n\n  @media (max-width: 1400px) {\n    width: 180px;\n  }\n\n  @media (max-width: 1200px) {\n    width: 160px;\n    padding-left: 16px;\n  }\n\n  @media (max-width: 992px) {\n    display: none;\n  }\n}\n\n.on-this-page-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin: 0 0 16px 0;\n}\n\n.on-this-page-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 24px;\n}\n\n.on-this-page-link {\n  font-size: 14px;\n  color: #5ea1d8;\n  text-decoration: none;\n  padding: 6px 0;\n  cursor: pointer;\n  transition: color 0.2s ease;\n\n  &:hover {\n    color: #4a8fc4;\n    text-decoration: underline;\n  }\n}\n\n.back-to-top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #666;\n  text-decoration: none;\n  padding: 8px 0;\n  cursor: pointer;\n  transition: color 0.2s ease;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &:hover {\n    color: #5ea1d8;\n  }\n}\n\n// Key Takeaway Box\n.key-takeaway {\n  background-color: #e3f2fd;\n  border-left: 4px solid #5ea1d8;\n  padding: 20px;\n  margin: 24px 0;\n  border-radius: 4px;\n\n  .key-takeaway-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 12px;\n\n    mat-icon {\n      color: #5ea1d8;\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n\n    .key-takeaway-title {\n      font-size: 16px;\n      font-weight: 600;\n      color: #212427;\n      margin: 0;\n    }\n  }\n\n  .key-takeaway-content {\n    color: #333;\n    line-height: 1.6;\n  }\n}\n\n// Data Collection Items\n.data-collection-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 16px;\n\n  mat-icon {\n    color: #5ea1d8;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    margin-top: 2px;\n    flex-shrink: 0;\n  }\n\n  .data-collection-content {\n    flex: 1;\n\n    strong {\n      color: #212427;\n      font-weight: 600;\n    }\n  }\n}\n\n// Two Column Layout\n.two-column-layout {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 30px;\n  margin: 24px 0;\n\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n  }\n\n  .column {\n    h4 {\n      font-size: 18px;\n      font-weight: 600;\n      color: #212427;\n      margin-bottom: 16px;\n    }\n\n    ul {\n      list-style: none;\n      padding-left: 0;\n\n      li {\n        padding-left: 20px;\n        position: relative;\n\n        &:before {\n          content: \"•\";\n          position: absolute;\n          left: 0;\n          color: #5ea1d8;\n          font-weight: bold;\n        }\n      }\n    }\n  }\n}\n\n// Footer\n.footer {\n  background: #000000;\n  color: #ffffff;\n  padding: 14px 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  margin-top: auto;\n\n  .copy-rights {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 0 24px;\n    width: 100%;\n\n    .row {\n      display: flex;\n      align-items: center;\n      margin: 0;\n      width: 100%;\n\n      @media (max-width: 768px) {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 16px;\n      }\n    }\n\n    .col-md-5,\n    .col-md-7,\n    .col-12 {\n      padding: 0;\n      display: flex;\n      align-items: center;\n\n      @media (max-width: 768px) {\n        width: 100%;\n        justify-content: flex-start;\n      }\n    }\n\n    .col-md-5 {\n      @media (min-width: 769px) {\n        justify-content: flex-start;\n      }\n    }\n\n    .col-md-7 {\n      @media (min-width: 769px) {\n        justify-content: flex-end;\n      }\n    }\n  }\n\n  .cpyrgt {\n    color: #64748b !important;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    line-height: 1.5;\n    width: 100%;\n\n    @media (max-width: 768px) {\n      flex-wrap: wrap;\n    }\n\n    li {\n      color: #64748b !important;\n      margin: 0;\n      padding: 0;\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n\n      a {\n        color: #64748b !important;\n        text-decoration: none;\n        margin-left: 4px;\n\n        &:hover {\n          color: #5ea1d8 !important;\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n\n  .f-menu-right {\n    display: flex;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    align-items: center;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    gap: 0;\n    width: 100%;\n\n    @media (max-width: 768px) {\n      justify-content: flex-start;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 8px;\n    }\n\n    li {\n      margin: 0;\n      padding: 0;\n\n      @media (min-width: 769px) {\n        &:not(:last-child)::after {\n          content: \"|\";\n          margin: 0 12px;\n          color: #64748b;\n        }\n      }\n\n      a {\n        color: #64748b !important;\n        text-decoration: none;\n        font-size: 14px;\n        transition: color 0.2s ease;\n\n        &:hover {\n          color: #5ea1d8 !important;\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n}\n\n// Override global mobile footer hiding for Legal pages\n@media screen and (max-width: 992px) {\n  :host footer,\n  :host .footer,\n  .legal-page footer,\n  .legal-page .footer,\n  app-legal-center-layout footer,\n  app-legal-center-layout .footer {\n    display: block !important;\n    visibility: visible !important;\n  }\n}\n\n// ============================================================\n// Light Mode Overrides — match how-it-works page header/footer\n// ============================================================\n:host-context(body.theme-light) {\n\n  // ── Header ──────────────────────────────────────────────\n  .legal-pages-header {\n    background: rgba(255, 255, 255, 0.95) !important;\n    border-bottom-color: rgba(0, 0, 0, 0.08) !important;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n    backdrop-filter: blur(20px) !important;\n  }\n\n  .legal-menu-button {\n    color: #0f172a !important;\n    &:hover { background-color: rgba(0, 0, 0, 0.06) !important; }\n  }\n\n  .legal-header-nav-link {\n    color: rgba(15, 23, 42, 0.75) !important;\n    &:hover { color: #5ea1d8 !important; }\n  }\n\n  .legal-sign-in-btn {\n    background-color: #5ea1d8 !important;\n    color: #ffffff !important;\n    &:hover { background-color: #4a8fc4 !important; }\n  }\n\n  // ── Footer ───────────────────────────────────────────────\n  .footer {\n    background: #f1f5f9 !important;\n    color: #475569 !important;\n    border-top-color: rgba(0, 0, 0, 0.08) !important;\n\n    .cpyrgt li,\n    .cpyrgt li a,\n    .f-menu-right li a { color: #64748b !important; }\n\n    .cpyrgt li a:hover,\n    .f-menu-right li a:hover { color: #5ea1d8 !important; }\n\n    .f-menu-right li:not(:last-child)::after {\n      color: rgba(100, 116, 139, 0.5) !important;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
